export const COLORS = {
  C_PRIMARY: "#0e93e5",
  C_SECOND: "#FCE9D2",
  C_THIRD: "#201F57",
  C_FORTH: "#8fa2f7",
  C_DARK: "#0D1539",
  C_TEXT: "#2f3838",
  C_BLACK: "#070C24",
  C_WHITE: "#ffffff",
  C_GRAY: "#8A92A5",
  C_BAC: "#8A92A5",
  C_GRAY_L2: "#FCFCFC",
  C_BLUE_LIGHT: "#28375A",
  C_BLUE_DARK: "#002E74",
  C_GREEN: "#40E3BE",
  C_RED: "#FF5A93",
  C_GOLD: "D4A017",
  C_BACKGROUND: "#EFF3F8",
  C_WARNING: "#b89335",
  C_SUCCESS: "#41ad6a",
  C_DANGER: "#f26262",
  C_DANGER_BACKGROUND: "#ffe3e3",
  C_MALE: "#02B0F0",
  C_FEMALE: "#EF5890",

  C_RAND_DFF: "#968DFF",
  C_RAND_0D1: "#49A0D1",
  C_RAND_5CC: "#0BB5CC",
  C_RAND_BFF: "#4F4BFF",
  C_RAND_5FD: "#C975FD",
  C_RAND_DD7: "#87ADD7",
  C_RAND_BF8: "#FD7BF8",

};
